import { render, staticRenderFns } from "./move_work_item_modal.vue?vue&type=template&id=1f10bad4"
import script from "./move_work_item_modal.vue?vue&type=script&lang=js"
export * from "./move_work_item_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports